import { combineReducers } from 'redux';

import payment from './Payment';

export default combineReducers({
  payment,
});
